module.exports = __webpack_public_path__ + "img/brasao-diretor-estado.3f1f0050.png";